// extracted by mini-css-extract-plugin
module.exports = {"atm_7l_1emz6l0":"atm_7l_1emz6l0"};